'use client';

import type { Mindmap } from '@/features/mindmap/core/MindmapTypes';

export type NodePositions = Record<string, { x: number; y: number } | undefined>;

/**
 * Returns node IDs under the given parent (or root when parentId is null),
 * sorted by their visual Y position and falling back to `order` when equal.
 * Useful for keyboard navigation and drag-reorder computations.
 */
export function getSiblingsSortedByPosition(
  doc: Mindmap,
  positions: NodePositions,
  parentId: string | null
): string[] {
  return doc.nodes
    .filter((node) => node.parentId === parentId)
    .map((node) => {
      const pos = positions[node.id];
      return {
        id: node.id,
        y: pos?.y ?? (parentId ? positions[parentId]?.y ?? 0 : 0),
        order: node.order,
      };
    })
    .sort((a, b) => {
      if (a.y === b.y) return a.order - b.order;
      return a.y - b.y;
    })
    .map((entry) => entry.id);
}

